<template>
  <div class="main-page-container">
    <AlertFoundActiveSession />
    <PageHeader
      className="d-flex align-items-center"
      :title="$t('exportList.title')"
    />
    <!-- grid -->
    <section
      class="export-list-table export-list-white-bg-sec"
      style="background-color: white"
    >
      <DxDataGrid
        id="gridExportList"
        :data-source="rowsData"
        :ref="dataGridRefName"
        :remote-operations="true"
        :showBorders="false"
        :columnAutoWidth="true"
        :allowColumnReordering="true"
        :allowColumnResizing="true"
        :rowAlternationEnabled="false"
        :showColumnLines="true"
        :showRowLines="true"
        :repaint-changes-only="true"
        :two-way-binding-enabled="true"
        :no-data-text="$t('common.grid.noRecordsYet')"
        @editor-preparing="onEditorPreparing($event)"
        @content-ready="contentReady($event)"
        @data-error-occurred="onDataErrorOccurred($event)"
        :rtl-enabled="rtlEnabled"
      >
        <DxScrolling mode="standard" :scroll-by-content="rtlEnabled" :use-native="!rtlEnabled" />
        <DxPaging :page-size="50" />

        <DxPager
          :visible="rowsData.length ? true : false"
          :allowed-page-sizes="[5, 10, 25, 50, 100]"
          :display-mode="'full'"
          :show-page-size-selector="true"
          :show-info="true"
          :show-navigation-buttons="true"
          :infoText="rtlEnabled ?  'صفحة {0} من {1} ({2} إجمالي العناصر)' : ''"
        />

        <DxFilterRow :visible="true" />
        <DxSorting mode="single" />
        <DxHeaderFilter :visible="true" />
        <DxColumnChooser
          :enabled="true"
          mode="select"
          :title="$t('common.grid.columnChooser')"
        />

        <DxToolbar>
          <DxItem location="before" template="columnButtonTemplate" />
          <DxItem location="before" template="clearAllTemplate" />
        </DxToolbar>

        <DxColumn
          data-field="requested_by"
          :caption="$t('exportList.requestedBy')"
          :allow-header-filtering="false"
          :filter-operations="allowedOperations"
          :visible="true"
        />

        <DxColumn
          data-field="generation_date"
          format="dd/MM/yyyy HH:mm:ss"
          :caption="$t('exportList.generationDate')"
          :allow-editing="false"
          :visible="true"
          :allow-filtering="true"
          :filter-operations="allowedOperations"
          :allow-header-filtering="true"
        />

        <DxColumn
          data-field="expiry_date"
          :caption="$t('exportList.expiryDate')"
          format="dd/MM/yyyy HH:mm:ss"
          :allow-editing="false"
          :visible="true"
          :allow-filtering="true"
          :filter-operations="allowedOperations"
          :allow-header-filtering="true"
        />

        <DxColumn
          data-field="type"
          :caption="$t('exportList.grid')"
          :allow-header-filtering="true"
          :visible="true"
          :allow-filtering="false"
          :filter-operations="allowedOperations"
        />

        <DxColumn
          data-field="name"
          :caption="$t('exportList.type')"
          :allow-header-filtering="true"
          :visible="true"
          :allow-filtering="false"
          :filter-operations="allowedOperations"
        />

        <DxColumn
          data-field="actions"
          :caption="$t('common.grid.actions')"
          :allow-filtering="false"
          :allow-exporting="false"
          :allow-editing="false"
          :visible="true"
          :allow-sorting="false"
          cell-template="action-cell"
        />

        <template #action-cell="{ data }">
          <a
            class="download-export-btn"
            :href="`${base_URL}${data.data.url}`"
            target="_blank"
            download
            >{{ $t("common.download") }}</a
          >
        </template>

        <template #columnButtonTemplate>
          <button class="custom-columns" @click="dataGrid.showColumnChooser()">
            <span class="custom-text">{{ $t("common.grid.columns") }} </span>
            <span class="custom-icon">
              <i class="dx-icon dx-icon-spindown dx-icon-right"></i>
            </span>
          </button>
        </template>

        <template #clearAllTemplate>
          <div v-if="showClearAll" class="clear-cols d-flex align-items-center">
            <div class="toolbar-custom-line"></div>
            <Button
              :text="$t('common.grid.clearFilters')"
              @click="reset()"
              styling-mode="outlined"
              type="danger"
              class="clear-CustomColums"
            />
          </div>
        </template>
      </DxDataGrid>
    </section>
  </div>
</template>

<script>
const dataGridRefName = "dataGridEmergencySessions";
import { mapActions, mapGetters } from "vuex";
import PageHeader from "../../../components/page-header.vue";
import { default as Button } from "devextreme-vue/button";
import AlertFoundActiveSession from "@/components/emergency/AlertFoundActiveSession";

import DxDataGrid, {
  DxColumn,
  DxFilterRow,
  DxHeaderFilter,
  DxToolbar,
  DxItem,
  DxPaging,
  DxPager,
  DxSorting,
  DxScrolling,
  DxColumnChooser,
} from "devextreme-vue/data-grid";
export default {
  name: "ExportList",
  title: "Export List",
  components: {
    PageHeader,
    DxDataGrid,
    DxColumn,
    DxFilterRow,
    DxHeaderFilter,
    DxToolbar,
    DxItem,
    DxPaging,
    DxPager,
    DxSorting,
    Button,
    DxScrolling,
    AlertFoundActiveSession,
    DxColumnChooser,
  },
  data() {
    return {
      title: "Export List",
      dataGridRefName,
      allowedOperations: ["contains"],
      base_URL: process.env.VUE_APP_BASE_URL,
      showClearAll: false,
      allExportList: [],
      rtlEnabled: false,
    };
  },
  methods: {
    ...mapActions("grid", [
      "onTableHeader",
      "resetTableHeaders",
      "resetFilterValues",
    ]),
    ...mapActions("exportConfig", ["fetchExportList"]),
    onEditorPreparing(e) {
      if (e.parentType == "filterRow") {
        e.editorOptions.placeholder = this.$t("common.grid.search");
      }
    },
    reset() {
      this.dataGrid.clearFilter("row");
      this.dataGrid.clearFilter("header");
      this.dataGrid.clearSorting();
      this.showClearAll = false;
    },
    contentReady(e) {
      let sortedExp = this.getSortedColumns();
      let filterExp = e.component.getCombinedFilter();
      if (filterExp || sortedExp) {
        this.showClearAll = true;
      } else {
        this.showClearAll = false;
      }
      this.setColumnChooserPosition();
    },
    getSortedColumns() {
      let allColumns = Array.from(
        Array(this.dataGrid.columnCount()).keys()
      ).map((index) => this.dataGrid.columnOption(index));
      allColumns = allColumns.find((col) => col.sortIndex != null);
      return allColumns;
    },
    setColumnChooserPosition() {
      var columnChooserView = this.dataGrid.getView("columnChooserView");
      if (!columnChooserView._popupContainer) {
        columnChooserView._initializePopupContainer();
        columnChooserView.render();
      }
      columnChooserView._popupContainer.option("position", {
        of: this.dataGrid.element(),
        my: this.rtlEnabled ? "right top" : "left top",
        at: this.rtlEnabled ? "right top" : "left top",
        offset: "0 50",
      });
    },
    onDataErrorOccurred(e) {
      console.log("onDataErrorOccurred e", e);
      setTimeout(() => {
        let errorRow = document.querySelector(
          ".dx-datagrid-headers .dx-error-message"
        );
        errorRow.innerHTML = this.$t("common.notes.anErrorOccurredGrid");
      }, 100);
    },
  },
  computed: {
    ...mapGetters("i18N", ["getLanguage"]),
    ...mapGetters("grid", ["getLoading", "getTableHeaders"]),
    ...mapGetters("exportConfig", ["getExportList"]),
    rowsData() {
      return this.allExportList && this.allExportList.length > 0
        ? this.allExportList.map((item) => {
            let name = "-";
            if (item.name) {
              name = item.name.split(".").pop();
              name = name.charAt(0).toUpperCase() + name.slice(1);
            }

            return {
              requested_by: `${item.first_name ? item.first_name : ""} ${
                item.last_name ? item.last_name : ""
              }`,
              generation_date: item.generation_date
                ? item.generation_date.split("-").reverse().join("/")
                : "-",
              expiry_date: item.expiry_date ? item.expiry_date.split("-").reverse().join("/") : "-",
              type: item.type ? item.type : "-",
              name: name,
              // type: item.type ? `${item.type} - ${item.name.split(".").pop()}` : "-",
              url: item.url,
            };
          })
        : [];
    },
    dataGrid() {
      return this.$refs[this.dataGridRefName].instance;
    },
  },
  created() {
    document.addEventListener("mousedown", (e) => {
      if (e.path) {
        let isColumnChooser = false;
        for (let i = 0; i < e.path.length; i++) {
          if (typeof e.path[i].matches == "function") {
            if (e.path[i].matches(".dx-overlay-content")) {
              isColumnChooser = true;
            }
          }
        }
        if (!isColumnChooser) this.dataGrid.hideColumnChooser();
      }
    });
  },
  beforeMount() {
    if (this.getLanguage == "ar") {
      this.rtlEnabled = true;
    }
    this.fetchExportList().then((data) => {
      // console.log('data', data);
      this.allExportList = data.data;
    });
  },
};
</script>

<style lang="scss" scoped>
button.btn.d-flex.align-items-center.text-center.join-btn.btn-secondary.dx-template-wrapper {
  display: flex;
  background: #34c38f;
  border-radius: 12.5px;
  height: 25px !important;
  width: 124px !important;
  display: flex;
  justify-content: center;
  border: none;
  font-weight: 700;
  font-size: 16px;
  line-height: 18px;
  text-align: center;
  color: #ffffff;
}
.circle {
  width: 100px;
  height: 100px;
  background: #34c38f;
  border-radius: 50%;
}
.text-success {
  color: #34c38f;
}

p {
  font-size: 12px;
  color: #b9b7b7;
}

img {
  height: 42px;
}

.export-list-table {
  tbody {
    color: #495057;
  }
}

.white-bg-sec {
  background-color: white;
  border-radius: 8px;
}

button.btn.d-flex.align-items-center.justify-content-center.text-center.session-btn.btn-primary.btn-sm.rounded-pill {
  margin-inline-start: 40px;
  height: 27px;
  width: 127px;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #ffffff;
}
</style>

<style lang="scss">
div#gridExportList {
  .dx-datagrid-filter-row
    .dx-menu
    .dx-menu-horizontal
    .dx-menu-items-container {
    top: 0px !important;
  }
}

.export-list-white-bg-sec {
  background-color: white;
  padding-inline-start: 0px;
  // padding-top: 25px;
  border-radius: 8px !important;

}
</style>
